module.exports = __webpack_public_path__ + "static/hyperv_20.c8170658.jpg";